import {
  Anchor,
  Checkbox,
  csx,
  Flex,
  Stack,
  Text,
  useCheckboxState,
} from '@vtex/admin-ui'
import { useWatch } from '@vtex/admin-ui-form'
import { FormattedMessage, useIntl } from 'react-intl'

import { useFormStateContext } from '../../../providers'
import { HighligthIllustration } from './HighlightIllustration'

type IllustrationProps = {
  highlight: boolean
}

function Illustration(props: IllustrationProps) {
  const { highlight } = props

  return (
    <Flex
      data-testid="promotion-highlight-illustration"
      direction="column"
      className={csx({
        background: '#FAFAFA',
        width: 'fit-content',
        padding: '$space-4',
        border: '$neutral',
        borderRadius: 4,
      })}
    >
      <Text
        tone="secondary"
        variant="detail"
        className={csx({ paddingLeft: '$space-1', paddingBottom: '$space-4' })}
      >
        <FormattedMessage id="admin/promotions.form.storefront.highlight.illustration.title" />
      </Text>

      <HighligthIllustration badge={highlight} />
    </Flex>
  )
}

type PromotionHighlightProps = {
  name: string
}

export function PromotionHighlight(props: PromotionHighlightProps) {
  const { name } = props
  const { formatMessage } = useIntl()
  const { form, readOnly } = useFormStateContext()
  const highlighted: boolean = useWatch({ form, name })

  const state = useCheckboxState({ initialValue: highlighted })

  return (
    <Stack space="$space-5">
      <Checkbox
        state={state}
        disabled={readOnly}
        label={formatMessage({
          id: 'admin/promotions.form.storefront.highlight',
        })}
        helpText={formatMessage(
          {
            id: 'admin/promotions.form.storefront.highlight.help-text',
          },
          {
            a: (content: any) => (
              <Anchor
                target="_blank"
                href={formatMessage({
                  id: 'admin/promotions.links.storefront.highlight',
                })}
              >
                {content}
              </Anchor>
            ),
          }
        )}
        onChange={({ target: { checked } }) => {
          form.setValue(name, checked)
        }}
      />

      <Illustration highlight={Boolean(state.value)} />
    </Stack>
  )
}
